// ----------------------------------------------------------------------

const account = {
  displayName: 'Mike Cleek',
  email: 'mike@relieffactor.com',
  photoURL: '/assets/images/avatars/avatar.png',
};

export default account;
